<template>
  <div>
    <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
        <v-row>
          <v-col cols="12">
            <v-sheet tile height="54" class="d-flex">
              <!-- วัน -->
              <v-select
                v-model="day"
                :items="dayName"
                dense
                outlined
                hide-details
                label="วัน"
                class="ma-2"
              ></v-select>
              <!-- เดือน -->
              <v-select
                v-model="month"
                :items="monthNameTH"
                dense
                outlined
                hide-details
                label="เดือน"
                class="ma-2"
              ></v-select>
              <!-- ปี -->
              <v-select
                v-model="year"
                :items="yearsNumber"
                dense
                outlined
                hide-details
                label="ปี"
                class="ma-2"
              ></v-select>
              <!-- ค้นหา -->
              <v-icon
                color="#871B12"
                size="30"
                @click="getDataToday()"
                >mdi-calendar-search</v-icon
              >
            </v-sheet>
          </v-col>
        </v-row>
        <v-row >
          <v-col cols="6">
            <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), exportToday()"
            >
               รายงานสรุปรายวัน
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn>
              <!-- <v-btn
              :loading="loading3"
              :disabled="loading3"
              color="blue-grey"
              class="ma-2 white--text"
              @click="(loader = 'loading3'), exportReportMonth()"
            >
              รายงานสรุปรายเดือน
              <v-icon right dark> mdi-cloud-download </v-icon>
            </v-btn> -->
          </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-alert
      color="#325ca8"
      dark
      icon="mdi-map-marker"
      dense
    >
      การเข้างาน Check IN-OUT
        </v-alert>
        <v-row>
           <v-col cols="6">
              <v-card>
                <canvas id="myChart"></canvas>
            </v-card>
          </v-col>
          <v-col cols="6">
            <v-row>
            <v-col cols="3">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title class="text-h5"> -->
                      เข้างานเวลาปกติ
                    <!-- </v-list-item-title> -->
                    <!-- <v-list-item-subtitle
                      ></v-list-item-subtitle
                    > -->
                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12"> {{coutOnTime}}  </v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title class="text-h5"> -->
                      เข้างานสาย
                    <!-- </v-list-item-title> -->

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12"> {{coutLate}}  </v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title class="text-h5"> -->
                      วันหยุด
                    <!-- </v-list-item-title> -->

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12"> {{empCountHoliday}}  </v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
            <v-col cols="3">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title class="text-h5"> -->
                      ลาหยุด
                    <!-- </v-list-item-title> -->

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12"> {{countLeave}}  </v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>

            <!-- <v-col cols="4">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                        ขาดงาน

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12"> {{coutAbsent}}</v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col> -->
            <v-col cols="4">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title class="text-h5"> -->
                        เข้างาน
                    <!-- </v-list-item-title> -->

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12">{{coutOnTime+coutLate}}</v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title > -->
                      ไม่พบข้อมูล
                    <!-- </v-list-item-title> -->

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12"> {{countNoCheckIn}}</v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card class="mx-auto" elevation="5">
                <v-list-item two-line>
                  <v-list-item-content>
                    <!-- <v-list-item-title > -->
                      รวมกะวันนี้/พนักงานทั้งหมด
                    <!-- </v-list-item-title> -->

                  </v-list-item-content>
                </v-list-item>

                <v-card-text>
                  <v-row align="center">
                    <v-col class="text-h3" cols="12">{{dataItem.length}}/{{empCountAll}}</v-col>
                  </v-row>
                </v-card-text>

              </v-card>
            </v-col>
              </v-row>
          </v-col>

        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-alert
       color="#2A3B4D"
      dark
      icon="mdi-city"
      dense
    >
     สถานที่ทำงาน
        </v-alert>
         <v-row>
           <v-col cols="6">
                <v-card>
                  <canvas id="myChartWork"></canvas>
                </v-card>
          </v-col>
            <v-col cols="6">
               <v-row>
              <v-col cols="6">
                <v-card class="mx-auto" elevation="5">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <!-- <v-list-item-title class="text-h5"> -->
                        ทำงานที่ออฟฟิต
                      <!-- </v-list-item-title> -->

                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text>
                    <v-row align="center">
                      <v-col class="text-h3" cols="12"> {{workOffice}} </v-col>
                    </v-row>
                  </v-card-text>

                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="mx-auto" elevation="5">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <!-- <v-list-item-title class="text-h5"> -->
                        ทำงานที่บ้าน
                      <!-- </v-list-item-title> -->

                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text>
                    <v-row align="center">
                      <v-col class="text-h3" cols="12"> {{workFromHome}} </v-col>
                    </v-row>
                  </v-card-text>

                </v-card>
              </v-col>
              <v-col cols="6">
                <v-card class="mx-auto" elevation="5">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <!-- <v-list-item-title class="text-h5"> -->
                        เข้างานนอกออฟฟิต
                      <!-- </v-list-item-title> -->

                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text>
                    <v-row align="center">
                      <v-col class="text-h3" cols="12"> {{workOutSite}} </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
                            <v-col cols="6">
                <v-card class="mx-auto" elevation="5">
                  <v-list-item two-line>
                    <v-list-item-content>
                      <!-- <v-list-item-title class="text-h5"> -->
                        รวม
                      <!-- </v-list-item-title> -->

                    </v-list-item-content>
                  </v-list-item>

                  <v-card-text>
                    <v-row align="center">
                      <v-col class="text-h3" cols="6"> {{workOffice + workFromHome + workOutSite}} </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
               </v-row>
            </v-col>
        </v-row>
        <v-divider class="mx-4"></v-divider>
        <v-row >
          <v-col cols="12">
            <v-text-field
              v-model="searchAll2"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-col>
          <!-- data table -->
          <v-col cols="12">
            <v-card elevation="7" v-if="dataReady">
              <v-card-text>
                 <v-data-table
                      :headers="columns"
                      :items="dataItem"
                      :search="searchAll2"
                      :items-per-page="20"
                    >
                      <template v-slot:[`item.CREATE_DATE`]="{ item }">
                        {{ format_date(item.CREATE_DATE) }}
                      </template>
                       <template v-slot:[`item.empImageUrl`]="{ item }">
                        <v-avatar
                             size="72"
                          >
                            <img
                              v-if="item.empImageUrl"
                              alt="Avatar"
                              :src="item.empImageUrl"
                            >
                          </v-avatar>
                      </template>

                      <template v-slot:[`item.color`]="{ item }">
                        <v-chip
                          v-if="item.color === 'สีเขียว'"
                          class="ma-2"
                          color="green"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีเหลือง'"
                          class="ma-2"
                          color="yellow"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีส้ม'"
                          class="ma-2"
                          color="orange"
                          text-color="black"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip
                          v-if="item.color === 'สีแดง'"
                          class="ma-2"
                          color="red"
                          text-color="white"
                        >
                          {{ item.color }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="!item.color">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.detail`]="{ item }">
                        <v-chip
                          v-if="item.detail === 'สาย'"
                          class="ma-2"
                          color="pink"
                          label
                          text-color="white"
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip
                          v-if="item.detail === 'ปกติ'"
                          class="ma-2"
                          color="primary"
                          label
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip
                          v-if="item.detail === 'วันหยุด'"
                          class="ma-2"
                          color="black"
                          text-color="white"
                          label
                        >
                          {{ item.detail }}
                        </v-chip>
                        <v-chip class="ma-2" v-if="item.detail == 'ไม่พบข้อมูล'">
                          ไม่พบข้อมูล
                        </v-chip>
                      </template>
                      <template v-slot:[`item.LAST_DATE`]="{ item }">
                        {{ format_date(item.LAST_DATE) }}
                      </template>
                      <template v-slot:[`item.action`]="{ item }">
                        <v-btn
                          color="success"
                          fab
                          small
                          @click.stop="(dialog = true), getByEmp(item)"
                        >
                          <v-icon dark> mdi-map-marker </v-icon>
                        </v-btn>
                      </template>
                    </v-data-table>
              </v-card-text>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
          <!-- end data table -->
          <v-dialog
            v-model="dialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>รายละเอียด</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>

              <v-col cols="12">
                <v-btn color="blue-grey" class="ma-2 white--text" @click="exportByEmp()">
                      Export รายเดือน
                      <v-icon right dark> mdi-download </v-icon>
                </v-btn>
                <v-expansion-panels v-model="panel" multiple>
                  <v-expansion-panel>
                    <v-expansion-panel-header disable-icon-rotate>
                      <template v-slot:actions>

                        <v-icon color="#871B12">
                          mdi-account-circle-outline
                        </v-icon>
                      </template>
                      {{ dataByEmpView.empFull_NameTH }}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="3">
                              <v-card elevation="2">
                                <center>
                                  <v-avatar
                                    class="profile"
                                    style="margin-top: 10px"
                                    color="grey"
                                    size="164"
                                    rounded
                                  >
                                    <v-img :src="dataByEmpView.empImageUrl"></v-img>
                                  </v-avatar>
                                </center>
                                <v-col>
                                  <v-card-text
                                    ><v-icon color="#871B12">mdi-account</v-icon
                                    ><strong>ชื่อ-นามสกุล: </strong
                                    >{{ dataByEmpView.empFull_NameTH }}
                                  </v-card-text>
                                  <v-card-text>
                                    <v-icon color="#871B12">mdi-account</v-icon>
                                    <strong>หน่วยงาน: </strong
                                    >{{ dataByEmpView.masDepartmentName }}
                                  </v-card-text>
                                  <v-card-text>
                                    <v-icon color="#871B12">mdi-account</v-icon>
                                    <strong>สาขา : </strong
                                    >{{ dataByEmpView.masBranchName }}
                                  </v-card-text>
                                  <v-card-text
                                    ><v-icon color="#871B12">mdi-account-box</v-icon
                                    ><strong>รหัสพนักงาน : </strong
                                    >{{ dataByEmpView.empCode }}</v-card-text
                                  >
                                  <v-card-text
                                    ><v-icon color="#871B12"> mdi-cellphone-basic </v-icon
                                    ><strong>เบอร์โทรศัพท์ : </strong
                                    >{{ dataByEmpView.empTel }}</v-card-text
                                  >
                                  <v-card-text
                                    ><v-icon color="#871B12"> mdi-email </v-icon
                                    ><strong>อีเมล์ : </strong>{{ dataByEmpView.empEmail }}
                                  </v-card-text>
                                </v-col>
                              </v-card>
                            </v-col>
<v-col cols="9">
                              <v-card elevation="2">
                                <v-simple-table  fixed-header height="530px">
                                  <template v-slot:default>
                                    <thead>
                                      <tr >
                                        <th class="text-center" style="background-color: #1B437C;">วัน/เดือน/ปี</th>
                                        <th class="text-center" style="background-color: #1B437C;">เวลาเข้างาน</th>
                                        <th class="text-center" style="background-color: #1B437C;">ระยะทาง</th>
                                        <th class="text-center" style="background-color: #1B437C;">เวลาเลิกงาน</th>
                                        <th class="text-center" style="background-color: #1B437C;">ระยะทาง</th>
                                        <th class="text-center" style="background-color: #1B437C;">เวลาสาย</th>
                                        <th class="text-center" style="background-color: #1B437C;">เวลาประเมิน</th>
                                        <th class="text-center" style="background-color: #1B437C;">สี</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="(
                                          items1, index1
                                        ) in dataByEmpView.shifttem"
                                        :key="index1"
                                      >
                                        <td>
                                          {{ items1.shiftDay }}/{{
                                            items1.shiftMonth
                                          }}/{{ items1.shiftYear }}
                                        </td>
                                        <td>
                                          <v-chip
                                            class="ma-2"
                                            :color="items1.colorin"
                                            text-color="white"
                                            @click="openWindows(items1)"
                                          >
                                            {{ items1.checkInStartStamp }}
                                          </v-chip>
                                        </td>
                                        <td>
                                          <v-chip
                                            class="ma-2"
                                            :color="items1.colorin"
                                            text-color="white"
                                            @click="openWindows(items1)"
                                          >
                                            {{ items1.checkInDistance }}
                                          </v-chip>
                                        </td>
                                        <td>
                                          <v-chip
                                            class="ma-2"
                                            :color="items1.colorout"
                                            text-color="white"
                                            @click="openWindows2(items1)"
                                          >
                                            {{ items1.checkInEndStamp }}
                                          </v-chip>
                                        </td>
                                        <td>
                                          <v-chip
                                            class="ma-2"
                                            :color="items1.colorout"
                                            text-color="white"
                                            @click="openWindows2(items1)"
                                          >
                                            {{ items1.checkOutDistance }}
                                          </v-chip>
                                        </td>
                                         <td>
                                          <v-chip
                                            class="ma-2"
                                            text-color="white"
                                            color="red"
                                            v-if="items1.lateTime !=='00:00' && items1.lateTime "
                                          >
                                            {{ items1.lateTime }}
                                          </v-chip>
                                          <v-chip
                                            class="ma-2"
                                            text-color="white"
                                            color="green"
                                            v-if="items1.lateTime ==='00:00'"
                                          >
                                            {{ items1.lateTime }}
                                          </v-chip>
                                          <v-chip
                                            class="ma-2"
                                            text-color="white"
                                            v-if="!items1.lateTime"
                                          >
                                            ไม่พบข้อมูล
                                          </v-chip>
                                        </td>

                                        <td v-if="items1.time_as" class="text-center">
                                            {{ items1.time_as }}
                                          </td>
                                          <td v-if="!items1.time_as" class="text-center">
                                            <v-chip class="ma-2"> ไม่พบข้อมูล </v-chip>
                                          </td>
                                          <td class="text-center">
                                            <v-chip
                                              v-if="items1.color === 'สีเขียว'"
                                              class="ma-2"
                                              color="green"
                                              text-color="white"
                                            >
                                              {{ items1.color }}
                                            </v-chip>
                                            <v-chip
                                              v-if="items1.color === 'สีเหลือง'"
                                              class="ma-2"
                                              color="yellow"
                                              text-color="black"
                                            >
                                              {{ items1.color }}
                                            </v-chip>
                                            <v-chip
                                              v-if="items1.color === 'สีแดง'"
                                              class="ma-2"
                                              color="red"
                                              text-color="black"
                                            >
                                              {{ items1.color }}
                                            </v-chip>
                                            <v-chip
                                              v-if="items1.color === 'สีส้ม'"
                                              class="ma-2"
                                              color="orange"
                                              text-color="black"
                                            >
                                              {{ items1.color }}
                                            </v-chip>
                                            <v-chip class="ma-2" v-if="!items1.color">
                                              ไม่พบข้อมูล
                                            </v-chip>
                                          </td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </v-simple-table>
                              </v-card>
                            </v-col>
                        <v-col cols="12">
                          <v-col>
                            <!-- {{dataByEmpView.shifttem}}
                        <label v-for="items2 in dataByEmpView.shifttem" :key="items2" >
                            {{items2.position}}
                            </label> -->
                            <!-- {{dataByEmpView.shifttem}} -->
                            <GmapMap
                              :center="center"
                              map-type-id="terrain"
                              ref="mapRef"
                              :zoom="zoom"
                              style="width: 100%; height: 600px"
                              :options="{ disableDefaultUI: true }"
                            >
                              <GmapMarker :position="center" />
                               <GmapMarker
                                v-for="(m, indexMap1) in dataByEmpView.shifttemMapCheckIn"
                                :key="indexMap1"
                                :position="m.positionIn"
                                :clickable="true"
                                :icon="m.iconIn"
                                @click="openWindows(m)"
                              />
                              <GmapMarker
                                v-for="(
                                  m2, indexMap2
                                ) in dataByEmpView.shifttemMapCheckIn"
                                :key="indexMap2 + 'M2'"
                                :position="m2.positionOut"
                                :clickable="true"
                                :icon="m2.iconOut"
                                @click="openWindows2(m2)"
                              />
                              <gmap-info-window
                                  @closeclick="window_open=false"
                                  :opened="window_open"
                                  :position="infowindow_position"
                                  :options="{
                                    pixelOffset: {
                                      width: 0,
                                      height: -35
                                    }
                                  }"
                              >
                                  {{infowindow_detail}}
                              </gmap-info-window>
                            </GmapMap>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-col>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import adminLeftMenu from '../../Sidebar.vue' // เมนู
import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
import XLSX from 'xlsx' // import xlsx
import readXlsxFile from 'read-excel-file'
import moment from 'moment' // แปลง date
import dayName from '../../../assets/master/Date/day.json'
import monthNameTH from '../../../assets/master/Date/monthNameTH.json'
import yearsNumber from '../../../assets/master/Date/yearsNumber.json'
import { gmapApi } from 'vue2-google-maps'
import Chart from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    downloadExcel: JsonExcel,
    XLSX,
    readXlsxFile,
    moment,
    gmapApi
  },
  created () {
    setInterval(this.getNowGlobal, 1000)
  },
  watch: {
    loader () {
      const l = this.loader
      this[l] = !this[l]

      setTimeout(() => (this[l] = false), 3000)

      this.loader = null
    }
  },
  data () {
    return {
      PK: '',
      center: {},
      session: this.$session.getAll(),
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'รายงานเช็คอิน - เช็คเอ้าท์ แผนก',
          disabled: false,
          href: '/CheckINOUT/ReportCheckINOUTTodayLeader'
        }
      ],
      dialog: false,
      dataReady: true,
      dateTime: '', // Generate DateTime
      searchAll2: '',
      loader: null,
      loading3: false,
      date: new Date().toISOString().substr(0, 10),
      // Data Table Config
      columns: [
        { text: 'ชื่อ - นามสกุล', value: 'empFull_NameTH' },
        { text: 'กะ', value: 'masShiftTypeName' },
        { text: 'สถานที่ทำงาน', value: 'location' },
        { text: 'Check IN', value: 'checkInStartStamp' },
        { text: 'ระยะ(KM)', value: 'checkInDistance' },
        { text: 'Check Out', value: 'checkInEndStamp' },
        { text: 'ระยะ(KM)', value: 'checkOutDistance' },
        { text: 'สถานะเข้างาน', value: 'detail' },
        { text: 'เวลาสาย', value: 'lateTime' },
        { text: 'color', value: 'color' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' }
      ],
      dataItem: [],
      export_data: [],
      export_data_by_month: [],
      dataByEmpView: [],
      BranchItem: [], // สาขา
      DepartmentItem: [], // แผนก
      CompanyItem: [], // บริษัท
      Company: this.$session.getAll().data.masCompanyCode, // บริษัท
      Branch: this.$session.getAll().data.masBranchCode, // บริษัท
      Department: this.$session.getAll().data.masDepartmentCode, // บริษัท
      disableBranch: true,
      disableDeparment: true,
      disableSearch: false,
      year: '',
      month: '',
      day: '',
      disableYear: true,
      disableMonth: true,
      dayName: dayName,
      monthNameTH: monthNameTH,
      yearsNumber: yearsNumber,
      panel: [0, 0],
      coutLate: 0,
      coutOnTime: 0,
      coutAbsent: 0,
      coutRiskDone: 0,
      coutRiskEmpty: 0,
      workOffice: 0,
      workFromHome: 0,
      workOutSite: 0,
      empCountAll: 0,
      empCountHoliday: 0,
      countNoCheckIn: 0,
      countLeave: 0,
      zoom: 14,
      window_open: false,
      infowindow_position: {lat: 10, lng: 10.0},
      infowindow_detail: ''
    }
  },
  async mounted () {
    await this.getGetToken()
    await this.geolocate()
    this.dataReady = false
    this.month = this.getMonthTh()
    let date = new Date()
    this.year = moment().format('YYYY')
    this.day = date.getDate()
    // await this.getDataCompany()
    await this.getDataToday()
  },
  methods: {
    geolocate () {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
          this.dataReady = true
          console.log('center : ', center)
          this.center = center
        },
        (error) => {
          console.log('error map :', error.message)
        }
      )
    },
    async getDataToday () {
      this.dataReady = false
      this.dataItem = []
      this.coutLate = 0
      this.coutOnTime = 0
      this.coutAbsent = 0
      this.coutRiskDone = 0
      this.coutRiskEmpty = 0
      this.workOffice = 0
      this.workFromHome = 0
      this.workOutSite = 0
      this.empCountHoliday = 0
      this.countNoCheckIn = 0
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?masDepartmentCode=' +
            this.$session.getAll().data.masDepartmentCode +
            '&shiftDay=' +
            this.day +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          this.dataItem = response.data
          this.dataItem.forEach((shifttem) => {
            // ประเมินความเสี่ยง
            if (shifttem.color) {
              this.coutRiskDone += 1
            } else {
              this.coutRiskEmpty += 1
            }

            if (shifttem.location === 'Office') {
              this.workOffice += 1
            }
            if (shifttem.location === 'WFH') {
              this.workFromHome += 1
            }
            if (shifttem.location === 'Outsite') {
              this.workOutSite += 1
            }
            if (shifttem.shiftCode === 'H') {
              this.empCountHoliday += 1
            }
            // Check IN OUT
            if (shifttem.checkInStartStamp) {
              // var date =
              //   shifttem.checkInYear +
              //   '-' +
              //   shifttem.checkInMonth +
              //   '-' +
              //   shifttem.checkInDay
              // var startStamp = new Date(
              //   date + ' ' + shifttem.checkInStartStamp
              // )
              // var masShiftTypeStartTime = new Date(
              //   date + ' ' + shifttem.masShiftTypeStartTime
              // )

              if (shifttem.lateStatus === 'ปกติ') {
                this.coutOnTime += 1
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
                this.coutLate += 1
              }

              if (shifttem.checkInEndStamp) {
                this.coutAbsent = this.coutAbsent + 1
              }
              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
                this.coutOnTime = this.coutOnTime - 1
                // this.workOffice = this.workOffice - 1
                // this.workFromHome = this.workFromHome - 1
                // this.workOutSite = this.workOutSite - 1
              }
              if (shifttem.leave !== null) {
                this.countLeave += 1
                shifttem.detail = shifttem.leave
                shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInStartStamp
                shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInEndStamp
                shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorin
                shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorout
              }
            } else {
              this.coutAbsent = this.coutAbsent + 1
              if (shifttem.shiftCode === 'H') {
                this.coutAbsent = this.coutAbsent - 1
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.detail = shifttem.leave
                  shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                  shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                  this.countLeave += 1
                } else {
                  shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                  this.countNoCheckIn += 1
                }
              }
            }
          })

          // this.coutAbsent = this.coutAbsent - this.empCountHoliday
          this.export_data = this.dataItem
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
          this.dataReady = true
        })
      this.coutAbsent = (this.coutAbsent < 0) ? 0 : this.coutAbsent
      this.coutOnTime = (this.coutOnTime < 0) ? 0 : this.coutOnTime
      this.coutLate = (this.coutLate < 0) ? 0 : this.coutLate
      this.workOffice = (this.workOffice < 0) ? 0 : this.workOffice
      this.workFromHome = (this.workFromHome < 0) ? 0 : this.workFromHome
      this.workOutSite = (this.workOutSite < 0) ? 0 : this.workOutSite

      await this.getDataCountEmployee()
      await this.charJSCheckINOUT()
      await this.charJSWork()
      // await this.charJSCovid()
    },
    async getByEmp (dt) {
      dt.empImageUrl = this.DNS_IP + '/' + dt.empImageUrl || ''
      this.dataByEmpView = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/get?empCode=' +
            dt.empCode +
            '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' +
            this.year
        )
        .then(async (response) => {
          dt.shifttem = response.data
          dt.shifttemMapCheckIn = response.data
          dt.shifttemMapCheckout = response.data
          this.mapGetDataCheckIn(dt.shifttemMapCheckIn)
          this.mapGetDataCheckOut(dt.shifttemMapCheckout)
          dt.shifttem.forEach((shifttem) => {
            if (shifttem.checkInStartStamp) {
              // var date =
              //   shifttem.checkInYear +
              //   '-' +
              //   shifttem.checkInMonth +
              //   '-' +
              //   shifttem.checkInDay
              // var startStamp = new Date(
              //   date + ' ' + shifttem.checkInStartStamp
              // )
              // var masShiftTypeStartTime = new Date(
              //   date + ' ' + shifttem.masShiftTypeStartTime
              // )

              shifttem.colorout = 'green'

              if (!shifttem.checkInEndStamp) {
                shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                shifttem.colorout = '-'
              }

              if (shifttem.lateStatus === 'ปกติ') {
                shifttem.detail = 'ปกติ'
                shifttem.colorin = 'green'
              }

              if (shifttem.lateStatus === 'สาย') {
                shifttem.colorin = 'red'
                shifttem.detail = 'สาย'
              }

              if (shifttem.shiftCode === 'H') {
                shifttem.detail = 'วันหยุด'
              }
              if (shifttem.leave !== null) {
                shifttem.detail = shifttem.leave
                shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInStartStamp
                shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : shifttem.checkInEndStamp
                shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorin
                shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : shifttem.colorout
              }
            } else {
              if (shifttem.shiftCode === 'H') {
                shifttem.checkInStartStamp = 'วันหยุด'
                shifttem.checkInEndStamp = 'วันหยุด'
                shifttem.detail = 'วันหยุด'
                shifttem.colorin = 'black'
                shifttem.colorout = 'black'
              } else {
                if (shifttem.leave !== null) {
                  shifttem.detail = shifttem.leave
                  shifttem.checkInStartStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? shifttem.leave : 'ไม่พบข้อมูล'
                  shifttem.colorin = (shifttem.leaveSummaryDayName === 'ครึ่งวันเช้า' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                  shifttem.colorout = (shifttem.leaveSummaryDayName === 'ครึ่งวันบ่าย' || shifttem.leaveSummaryDayName === 'เต็มวัน') ? 'blue' : '-'
                } else {
                  shifttem.checkInStartStamp = 'ไม่พบข้อมูล'
                  shifttem.checkInEndStamp = 'ไม่พบข้อมูล'
                  shifttem.detail = 'ไม่พบข้อมูล'
                  shifttem.colorin = '-'
                  shifttem.colorout = '-'
                }
              }
            }
          })
          dt.shifttem = dt.shifttem
            .slice()
            .sort((a, b) => a.shiftDay - b.shiftDay)
          this.dataByEmpView = dt
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
        })
    },
    mapGetDataCheckIn (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInStartLat && shifttem.checkInStartLong) {
          var position = {
            lat: parseFloat(shifttem.checkInStartLat),
            lng: parseFloat(shifttem.checkInStartLong)
          }

          shifttem.iconIn =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fin.png?alt=media'
          shifttem.positionIn = position
          this.center = position
        }
      })
    },
    mapGetDataCheckOut (dt) {
      dt.forEach((shifttem) => {
        // var position = {
        //   lat: null,
        //   lng: null
        // }
        if (shifttem.checkInEndLat && shifttem.checkInEndLong) {
          var position = {
            lat: parseFloat(shifttem.checkInEndLat),
            lng: parseFloat(shifttem.checkInEndLong)
          }

          shifttem.iconOut =
            'https://firebasestorage.googleapis.com/v0/b/betask-crm.appspot.com/o/marker%2Fout.png?alt=media'
          shifttem.positionOut = position
          this.center = position
        }
      })
    },
    openWindows (m) {
      console.log('m', m)
      this.zoom = 19
      this.center = m.positionIn
      this.window_open = true
      this.infowindow_position = m.positionIn

      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nเข้างานเมื่อ ' + m.checkInStartStamp
      // this.panToMarker(this.center)
    },
    openWindows2 (m) {
      console.log('m2', m)
      this.zoom = 19
      this.center = m.positionOut
      this.infowindow_position = m.positionOut
      this.window_open = true
      this.infowindow_detail = 'วันที่ ' + m.checkInDay + '/' + m.checkInMonth + '/' + m.checkInYear + '\nออกงานเมื่อ ' + m.checkInEndStamp
      // this.panToMarker(this.center)
    },
    async exportReportDaily () {
      this.dataReady = false
      // var Company = '&masCompanyName=' + this.$session.getAll().data.masCompanyName
      var Branch = '&masBranchName=' + this.$session.getAll().data.masBranchName
      var Department = '&masDepartmentName=' + this.$session.getAll().data.masDepartmentName
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/getOderEmp?shiftDay=' +
            this.day + '&shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' + this.year + Branch + Department
        )
        .then(async (response) => {
          this.dataReady = true
          var tem = []
          response.data.forEach((element) => {
            // console.log(element)
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ชื่อพนักงาน': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'ปี': element.shiftYear,
              'เดือน': element.shiftMonth,
              'วัน': element.shiftDay,
              'วันเดือนปี': element.shiftDay + '/' + element.shiftMonth + '/' + element.shiftYear,
              'รหัสกะ': element.masShiftTypeCode,
              'กะเข้างาน': element.masShiftTypeStartTime,
              'กะเวลาออกงาน': element.masShiftTypeEndTime,
              'สถานที่ทำงาน': element.location === null ? 'ไม่พบข้อมูล' : element.location,
              'เวลาเข้างาน': element.checkInStartStamp,
              'ระยะทางเข้างาน(KM)': element.checkInDistance,
              'เวลาออกงาน': element.checkInEndStamp,
              'ระยะทางออกงาน(KM)': element.checkOutDistance,
              'สถานะสาย': element.lateStatus === null ? 'ไม่พบข้อมูล' : element.lateStatus,
              'สาย(นาที)': element.lateTime === null ? 'ไม่พบข้อมูล' : element.lateTime,
              'สถานะออกก่อน': element.earlyStatus === null ? 'ไม่พบข้อมูล' : element.earlyStatus,
              'ออกก่อน(นาที)': element.earlyTime === null ? 'ไม่พบข้อมูล' : element.earlyTime,
              'Adjust': element.adjustStatus === null ? 'ไม่พบข้อมูล' : element.adjustStatus,
              'Adjust Remark': element.adjustRemark === null ? 'ไม่พบข้อมูล' : element.adjustRemark,
              'Adjust Header Remark': element.adjustRemarkHeader === null ? 'ไม่พบข้อมูล' : element.adjustRemarkHeader,
              'ระดับสีประเมินความเสี่ยง': element.color === null ? 'ไม่พบข้อมูล' : element.color,
              'ลา': element.leave === null ? 'ไม่พบข้อมูล' : element.leave,
              'location-in': element.checkInMapUrl === null ? 'ไม่พบข้อมูล' : element.checkInMapUrl,
              'location-out': element.checkOutMapUrl === null ? 'ไม่พบข้อมูล' : element.checkOutMapUrl,
              'โอที(นาที)': element.OT_MINUTE,
              'โอที(ชั่วโมง)': element.OT_HOURS,
              '1 เท่า': element.OTHOLIDAY,
              '1.5 เท่า': element.OTWORK

            }
            tem.push(s)
          })
          tem = tem
            .sort((a, b) => a.รหัสพนักงาน - b.รหัสพนักงาน || a.ปี - b.เดือน || a.วัน - b.วัน)
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'CheckInOut-Report(' + this.day + '-' + this.month + '-' + this.year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async exportReportMonth () {
      this.export_data_by_month = []
      this.dataReady = false
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP +
            '/shift_import/reportMonth?shiftMonth=' +
            this.getMonthThToINT(this.month) +
            '&shiftYear=' + this.year + '&masDepartmentName=' + this.$session.getAll().data.masDepartmentName + '&masBranchName=' +
            this.$session.getAll().data.masBranchName
        )
        .then(async (response) => {
          this.dataReady = false
          console.log(response.data)
          var tem = []
          response.data.forEach((element) => {
            let s = {
              'รหัสพนักงาน': element.empCode,
              'ชื่อพนักงาน': element.empFull_NameTH,
              'แผนก': element.masDepartmentName,
              'สาขา': element.masBranchName,
              'บริษัท': element.masCompanyName,
              'เดือน': this.month,
              'ปี': this.year,
              'Normal วัน/ด': element.Normal,
              'Actual เข้า/ด': element.Actual,
              'AFL': element.AFL,
              'Late นาที/ด': element.Late,
              'Early นาที/ด': element.Early,
              'No Check IN วัน': element.absent2,
              'No Check OUT วัน': element.absent1,
              'Adjust No IN': element.adjustStatusIN,
              'Adjust No OUT': element.adjustStatusOUT,
              'ลาป่วย': element.leaveSick,
              'ลากิจ': element.leaveBusiness,
              'ลาพักร้อน': element.leaveHoliday,
              'ลาอุปสมบท': element.leaveOrdination,
              'ลาคลอด': element.leaveMaternity,
              'ลาไม่รับค่าตอบแทน': element.leaveUnpaid,
              'รวมลา': element.totalLeave,
              'โอทีรวม/นาที': element.OTMinutes,
              'โอทีรวม/ชม': element.OTHours,
              'โอที 1.0': element.OTHours1,
              'โอที 1.5': element.OTHours15,
              'สลับกะ': element.TranferTotal
              // 'รวมลา': element.leaveSick + element.leaveMaternity + element.leaveBusiness + element.leaveHoliday + element.leaveOrdination

            }
            tem.push(s)
          })
          var info = XLSX.utils.json_to_sheet(tem)
          var wb = XLSX.utils.book_new() // make Workbook of Excel
          XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
          XLSX.writeFile(wb, 'CheckInOut-Report-Month(' + this.month + '-' + this.year + ').xls') // name of the file is 'book.xlsx'
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log(error)
        })
    },
    async exportByEmp () {
      console.log('Export Emp', this.dataByEmpView.shifttem)
      var tem = []
      // var wb = XLSX.utils.book_new() // make Workbook of Excel
      this.dataByEmpView.shifttem.forEach((element) => {
        let s = {
          'รหัสพนักงาน': element.empCode,
          'ชื่อพนักงาน': element.empFull_NameTH,
          'แผนก': element.masDepartmentName,
          'สาขา': element.masBranchName,
          'บริษัท': element.masCompanyName,
          'ปี': element.shiftYear,
          'เดือน': element.shiftMonth,
          'วัน': element.shiftDay,
          'วันเดือนปี': element.shiftDay + '/' + element.shiftMonth + '/' + element.shiftYear,
          'รหัสกะ': element.masShiftTypeCode,
          'กะเข้างาน': element.masShiftTypeStartTime,
          'กะเวลาออกงาน': element.masShiftTypeEndTime,
          'สถานที่ทำงาน': element.location,
          'เวลาเข้างาน': element.checkInStartStamp,
          'ระยะทางเข้างาน(KM)': element.checkInDistance,
          'เวลาออกงาน': element.checkInEndStamp,
          'ระยะทางออกงาน(KM)': element.checkOutDistance,
          'สถานะสาย': element.lateStatus,
          'สาย(นาที)': element.lateTime,
          'ระดับสีประเมินความเสี่ยง': element.color
        }
        tem.push(s)
      })
      console.log(tem)
      var info = XLSX.utils.json_to_sheet(tem)
      var wb = XLSX.utils.book_new() // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, info, 'worksheet') // sheetAName is name of Worksheet
      XLSX.writeFile(
        wb,
        'CheckInOut-Report(' + this.dataByEmpView.empFull_NameTH + '' +
          ' ' +
          this.month +
          ' ' +
          this.year +
          ').xls'
      ) // name of the file is 'book.xlsx'
    },
    async charJSCheckINOUT () {
      var ctx = document.getElementById('myChart')
      var myChart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        data: {
          labels: ['เข้างานเวลาปกติ', 'สาย', 'ขาดงาน', 'วันหยุด', 'ลาหยุด'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#41B883', '#E46651', '#ff1100', '#000000', '#2328c2'],
              data: [
                this.coutOnTime,
                this.coutLate,
                this.coutAbsent,
                this.empCountHoliday,
                this.countLeave
              ]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              color: 'white',
              textAlign: 'center',
              font: {
                weight: 'bold',
                size: 16
              }
            }
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 15,
              bottom: 0
            }
          },
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true
              }
            ]
          }
        }
      })
      console.log(myChart)
    },
    async charJSWork () {
      var ctx = document.getElementById('myChartWork')
      // eslint-disable-next-line no-new
      new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        data: {
          labels: ['เข้าออฟฟิต', 'Work From Homw', 'นอกสถานที'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#050091', '#009187', '#910063'],
              data: [this.workOffice, this.workFromHome, this.workOutSite]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              color: 'white',
              textAlign: 'center',
              font: {
                weight: 'bold',
                size: 16
              }
            }
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 15,
              bottom: 0
            }
          },
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true
              }
            ]
          }
        }
      })
    },
    async charJSCovid () {
      var ctx = document.getElementById('myChartCovid')
      // eslint-disable-next-line no-new
      new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: 'doughnut',
        data: {
          labels: ['ประเมินเรียบร้อย', 'ยังไม่ได้ประเมิน'],
          datasets: [
            {
              label: 'Data One',
              backgroundColor: ['#00ff1e', '#ff2a00'],
              data: [this.coutRiskDone, this.coutRiskEmpty]
            }
          ]
        },
        options: {
          responsive: true,
          plugins: {
            datalabels: {
              color: 'white',
              textAlign: 'center',
              font: {
                weight: 'bold',
                size: 16
              }
            }
          },
          layout: {
            padding: {
              left: 0,
              right: 0,
              top: 15,
              bottom: 0
            }
          },
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true
              }
            ]
          }
        }
      })
    },
    async getDataCountEmployee () {
      this.empCountAll = 0
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + "/employee/get?masBranchName=" + this.$session.getAll().data.masBranchName + '&masDepartmentName=' + this.$session.getAll().data.masDepartmentName,
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async (response) => {
          this.empCountAll = response.data.length
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>
<style scope>
.v-data-table-header {
  background-color: #1b437c !important;
}
.Color-Font {
  color: #808588;
}
.Color-Font-Action {
  color: #b61c1c;
}
.Color-Font-Preview {
  color: #262a34;
}
.Color-Button {
  color: #b61c1c;
}
.Divider {
  border: 2px solid #808588;
  background: #808588;
  border-radius: 5px;
}
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

.v-data-table-header {
  background-color: var(--table-head-bg) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/CheckINOUT/ReportCheckINOUTTodayLeader.vue